export default __webpack_public_path__ + "static/media/sneakerDetail2.b6fc5f5f.png";